import {
  informParticipationActions,
  informParticipationActionTypes,
} from 'modules/Taps/components/Situations/components/InformParticipation/redux/informParticipationActions';
import { put, race, take, takeLatest } from 'redux-saga/effects';
import {
  actionTypes as contactsActionTypes,
  startRequest as startRequestContacts,
} from 'modules/Contacts/redux/contacts/actions';

function* init() {
  yield put(startRequestContacts());

  yield race({
    success: take(contactsActionTypes.REQUEST_SUCCESS),
    failure: take(contactsActionTypes.REQUEST_FAILURE),
  });

  yield put(informParticipationActions.initFinishAction());
}

export default function* initSaga() {
  yield takeLatest(informParticipationActionTypes.INIT, init);
}
